import { IonButton, IonItem, IonLabel, IonSelect, IonSelectOption } from '@ionic/react';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { getCurrentUser, getCurrentUserUID, saveRecordPermissions } from '../firebase/firebase';
import { getUserIdFromPath, updateFileMetadata } from '../firebase/firebaseStorage';
import { getUser, getUsers } from '../firebase/users';


export function getPermissionsDisplay(p: any) {
  var owner = "";
  if (p.userId !== getCurrentUserUID()) {
    if (p.userId !== undefined) {
      owner += getUser(p.userId)?.initials + ": ";
    } else {
      owner += getUser(getUserIdFromPath(p.path))?.initials + ": ";
    }
  }
  var reads = "";
  var writes = "";
  if (getCurrentUser().role === "manager" || p.userId === getCurrentUserUID()) {
    var readKeys = [];
    var writeKeys = [];
    for (var key in p.permissions) {
      if (p.permissions[key] !== "none") {
        if (p.permissions[key] === "write") {
          writeKeys.push(key);
        } else {
          readKeys.push(key);
        }
      }
    }
    readKeys = readKeys.sort();
    writeKeys = writeKeys.sort();
    for (var k of readKeys) {
      try{
        reads += getUser(k).initials + " ";
      }catch(e){
        console.log(p.id);
        console.log(e);
      }
    }
    for (var k of writeKeys) {
      try{
      writes += getUser(k).initials + " ";
    }catch(e){
      console.log(p.id);
      console.log(e);
    }
    }
  }
  return (
    <div style={{ display: "flex", minWidth: "20px", color: "lightgray", fontSize: "8px", position: "absolute", top: "2px", width: "300px" }}>
      <div style={{ color: "blue", marginRight: "2px" }}>{owner}</div>
      <div style={{ color: "green", marginRight: "2px" }}>{reads}</div>
      <div style={{ color: "red", marginRight: "2px" }}>{writes}</div>
    </div>
  );
}

const Permissions: React.FC<{ collection: string, id: string, permissions: any, updateDate: any, db: boolean, goBackAfterSave: boolean }> = (props) => {
  const users = getUsers();
  const [permissions, setPermissions] = useState<any>();
  const history = useHistory();

  useEffect(() => {
    if (props.permissions === undefined) {
      setPermissions({});
    } else {
      setPermissions(JSON.parse(JSON.stringify(props.permissions)));
    }

  }, []);
  //if(permissions === undefined && props.permissions !== undefined){

  //}

  function updatePermissions(userId: string, value: string) {
    if (permissions !== undefined) {
      if (permissions[userId] !== value) {
        permissions[userId] = value;
        setPermissions(permissions);
      }
    }
  }
  function savePermissions() {
    if (props.db) {
      saveRecordPermissions(props.collection, props.id, permissions, props.updateDate);
    } else {
      updateFileMetadata(props.collection, { permissions: JSON.stringify(permissions) });
    }
    if (props.goBackAfterSave) {
      history.goBack();
    }
  }
  //console.log("Permissions", props, permissions);

  return (
    <div>
      {users.map((u: any) => (
        u.enabled || (permissions !== undefined && permissions[u.id] !== undefined && permissions[u.id]!=="none")?
        <IonItem key={u.id} >
          <IonLabel>{u.surname + " " + u.name}</IonLabel>
          <IonSelect slot="end" interface="popover" onIonChange={(e) => { updatePermissions(u.id, e.detail.value) }} value={permissions !== undefined && permissions[u.id] !== undefined ? permissions[u.id] : "none"} placeholder="uprawnienia">
            <IonSelectOption key="none" value="none">brak</IonSelectOption>
            <IonSelectOption key="read" value="read">odczyt</IonSelectOption>
            <IonSelectOption key="write" value="write">zapis</IonSelectOption>
          </IonSelect>
        </IonItem>
        : ""
      ))}
      <IonItem>
        <IonButton slot="end" onClick={savePermissions}>zapisz</IonButton>
      </IonItem>
    </div>

  );
};

export default Permissions;



